import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment, Router } from '@angular/router';
import { AuthService } from '../../services/auth';

export const redirectIfAuthGuard: CanMatchFn = (
  route: Route,
  segments: UrlSegment[]
) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const isLogged = auth.isLoggedIn();

  if (isLogged) {
    router.navigateByUrl('/dashboard');
    return false;
  }
  return true;
};
